import type { FunctionComponent, PropsWithChildren } from 'react';

import type { MarkdownParsedNodeType } from './MarkdownParser';

export interface MarkdownNodeProps extends PropsWithChildren {
  type: MarkdownParsedNodeType;
}

export const MarkdownNode: FunctionComponent<MarkdownNodeProps> = ({ type, children }) => {
  switch (type) {
    case 'b':
      return <b>{children}</b>;
    default:
      return <>{children}</>;
  }
};
